/**
 * Navigation Script
 * Handles mobile menu toggle and header scroll effect
 */

(function() {
    'use strict';

    // Mobile menu toggle
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const navigation = document.querySelector('.main-navigation');
    const siteHeader = document.querySelector('.site-header');

    // Detect if this is the home page (started with transparent header)
    const isHomePage = siteHeader && siteHeader.classList.contains('transparent');

    // Function to update header state based on scroll and menu state
    function updateHeaderState() {
        if (!siteHeader) return;

        const isMenuOpen = navigation && navigation.classList.contains('active');

        if (isMenuOpen) {
            // Mobile menu is open → always transparent (dark background menu)
            siteHeader.classList.remove('solid');
            siteHeader.classList.add('transparent');
        } else if (isHomePage) {
            // Home page → depends on scroll position
            if (window.scrollY > 100) {
                siteHeader.classList.remove('transparent');
                siteHeader.classList.add('solid');
            } else {
                siteHeader.classList.remove('solid');
                siteHeader.classList.add('transparent');
            }
        } else {
            // Other pages → always solid
            siteHeader.classList.remove('transparent');
            siteHeader.classList.add('solid');
        }
    }

    // Function to close mobile menu and restore body scroll
    function closeMobileMenu() {
        if (!navigation || !mobileMenuToggle) return;

        navigation.classList.remove('active');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
        updateHeaderState();
    }

    // Function to open mobile menu and block body scroll
    function openMobileMenu() {
        if (!navigation || !mobileMenuToggle) return;

        navigation.classList.add('active');
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('menu-open');
        updateHeaderState();
    }

    if (mobileMenuToggle && navigation) {
        // Toggle menu on hamburger click
        mobileMenuToggle.addEventListener('click', function() {
            const isMenuOpen = navigation.classList.contains('active');

            if (isMenuOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        // Close menu when clicking on any menu link (including anchor links)
        const menuLinks = navigation.querySelectorAll('a');
        menuLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                const isAnchorLink = href && href.includes('#');

                if (isAnchorLink) {
                    e.preventDefault();

                    // Extract the hash/anchor
                    const hashIndex = href.indexOf('#');
                    const targetId = href.substring(hashIndex + 1);
                    const targetElement = document.getElementById(targetId);

                    // First close menu and unlock scroll
                    closeMobileMenu();

                    // Then scroll to anchor after menu is closed
                    if (targetElement) {
                        setTimeout(function() {
                            targetElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }, 50);
                    }
                } else {
                    // Regular link - just close menu
                    closeMobileMenu();
                }
            });
        });

        // Close menu when clicking outside
        document.addEventListener('click', function(event) {
            const isClickInsideNav = navigation.contains(event.target);
            const isClickOnToggle = mobileMenuToggle.contains(event.target);

            if (!isClickInsideNav && !isClickOnToggle && navigation.classList.contains('active')) {
                closeMobileMenu();
            }
        });

        // Close menu on window resize (if larger than mobile)
        window.addEventListener('resize', function() {
            if (window.innerWidth >= 768 && navigation.classList.contains('active')) {
                closeMobileMenu();
            }
        });
    }

    // Header scroll effect
    if (siteHeader) {
        window.addEventListener('scroll', function() {
            // Only update if menu is not open
            if (!navigation || !navigation.classList.contains('active')) {
                updateHeaderState();
            }
        });
    }

    // Scroll Spy - Highlight menu items based on visible section
    function initScrollSpy() {
        const navLinks = document.querySelectorAll('.nav-menu a[href*="#"]');

        if (navLinks.length === 0) return;

        // Get all sections that have corresponding menu links
        const sections = [];
        navLinks.forEach(function(link) {
            const href = link.getAttribute('href');
            const hashIndex = href.indexOf('#');

            if (hashIndex !== -1) {
                const sectionId = href.substring(hashIndex + 1);
                const section = document.getElementById(sectionId);

                if (section) {
                    sections.push({
                        id: sectionId,
                        element: section,
                        link: link
                    });
                }
            }
        });

        if (sections.length === 0) return;

        // Update active section on scroll
        function updateActiveSection() {
            const scrollPosition = window.scrollY + 150; // Offset for header

            // Remove all current-section    classes
            navLinks.forEach(function(link) {
                link.parentElement.classList.remove('current-section');
            });

            // Find the current section
            let currentSection = null;

            sections.forEach(function(section) {
                const sectionTop = section.element.offsetTop;
                const sectionBottom = sectionTop + section.element.offsetHeight;

                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    currentSection = section;
                }
            });

            // Add current-section class to the active menu item
            if (currentSection) {
                currentSection.link.parentElement.classList.add('current-section');
            }
        }

        // Throttle scroll events for performance
        let ticking = false;
        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        });

        // Initial check
        updateActiveSection();
    }

    // Initialize scroll spy when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollSpy);
    } else {
        initScrollSpy();
    }
})();

